/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AnalyticsSummaryDetailInfo = {
    VAL?: string;
    CHGRT?: string;
    CHGDIR?: AnalyticsSummaryDetailInfo.CHGDIR;
};

export namespace AnalyticsSummaryDetailInfo {

    export enum CHGDIR {
        UP = 'UP',
        DOWN = 'DOWN',
        FLAT = 'FLAT',
    }


}

